import {
  Box,
  Container,
  IconButton,
  SwipeableDrawer,
  Typography,
  styled,
} from "@mui/material";

import Modal from "./Modal";
import useIsMobileView from "hooks/useIsMobileView";

export function BottomDrawer({
  open,
  onClose,
  title,
  children,
  dir,
  maxWidth,
}) {
  const isMobileView = useIsMobileView();

  return (
    <>
      {!isMobileView ? (
        <Modal
          maxWidth={maxWidth || "sm"}
          open={open}
          onClose={onClose}
          dir={dir}
          title={title}
        >
          {children}
        </Modal>
      ) : (
        <SwipeableDrawerStyle anchor="bottom" open={open} onClose={onClose}>
          <Container>
            <DrawerHeader dir={dir}>
              <Typography dir="rtl" variant="h4" dark="true">
                {title}
              </Typography>

              <IconButtonStyle onClick={onClose}>
                <ion-icon name="close"></ion-icon>
              </IconButtonStyle>
            </DrawerHeader>

            <ContentWrapper>{children}</ContentWrapper>
          </Container>
        </SwipeableDrawerStyle>
      )}
    </>
  );
}

const DrawerHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: theme.spacing(2),
}));

const IconButtonStyle = styled(IconButton)(({ theme }) => ({
  color: theme.palette.common.white,
}));

const ContentWrapper = styled(Box)(() => ({}));

const SwipeableDrawerStyle = styled(SwipeableDrawer)(({ theme }) => ({
  ".MuiPaper-root": {
    borderRadius: "20px 20px 0  0",
    padding: theme.spacing(3, 0),
  },
}));

export default BottomDrawer;
